// Import Vue
import Vue from 'vue';

import VueVisible from 'vue-visible';

// Import Framework7
import Framework7 from 'framework7/framework7-lite.esm.bundle.js';

// Import Framework7-Vue Plugin
import Framework7Vue from 'framework7-vue/framework7-vue.esm.bundle.js';

// Import Framework7 Styles
import 'framework7/css/framework7.bundle.css';

// Import Icons and App Custom Styles
import '../css/icons.css';
import '../css/app.css';
import 'font-awesome/css/font-awesome.css';

import moment from 'moment';

// Import App Component
import App from '../components/app.vue';

import Trans from '../js/trans.js';
import RenderBB from '../js/bb.js';
import Geolocation from '../js/geolocation.js';
import Preferences from '../js/preferences.js';

// Init Framework7-Vue Plugin
Framework7.use(Framework7Vue);

Vue.use(VueVisible);

Vue.filter('trans', Trans);
Vue.filter('bb', RenderBB);
Vue.filter('mapUrl', Geolocation.mapUrl);
Vue.mixin({
  data: function() {
    return {
      preferences: Preferences,
      listeners: []
    }
  },
  methods: {
    trans: Trans,
    bb: RenderBB,
    mapUrl: Geolocation.mapUrl,
    registerOn(obj, evt, callback) {
      obj.$on(evt, callback);
      this.listeners.push({obj: obj, type: '$on', evt: evt, callback: callback});
    },
    registerOnError(obj, evt, callback) {
      obj.$onError(evt, callback);
      this.listeners.push({obj: obj, type: '$onError', evt: evt, callback: callback});
    },
    registerOnce(obj, evt, callback) {
      obj.$once(evt, callback);
      this.listeners.push({obj: obj, type: '$once', evt: evt, callback: callback});
    },
  },
  beforeDestroy() {
    for (const listener of this.listeners) {
      switch (listener.type) {
        case '$once':
        case '$on':
          listener.obj.$off(listener.evt, listener.callback);
          break;
        case '$onError': listener.obj.$offError(listener.evt, listener.callback); break;
      }
    }
    this.listeners = [];
  }
});

// Init App
Trans.trySetUserDefault();
window.vueApp = new Vue({
  el: '#app',
  render: (h) => h(App),

  // Register App Component
  components: {
    app: App
  },
  mounted: function() {
    Trans.trySetUserDefault();
  }
});
